import React from 'react'
import { Heading } from 'components/Heading'
import { CallToAction } from 'components/CallToAction'
import GithubSlugger from 'github-slugger'
import { prepareData } from 'utils/googleData'

export function Hero(props) {
    const {
        enable,
        title,
        subtitle,
        video,
        description,
        cta,
        cards,
        direction,
        style,
        gatsbyImage,
        features,
        gatsbyTransformed,
    } = prepareData({ props })
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    const slugger = new GithubSlugger()
    const id = slugger.slug(title)
    return (
        <div className="mx-auto max-w-[849px] text-center">
            {title && (
                <Heading hideCopy id={id} as="h1" className="mt-0 mb-5 text-4xl leading-none md:text-[64px]">
                    <div dangerouslySetInnerHTML={{ __html: title }} />
                </Heading>
            )}
            {subtitle && (
                <h2 className="mb-8 !mt-5 text-[18px] font-semibold leading-[1.4] md:text-[20px]">{subtitle}</h2>
            )}
            {cta && (
                <div className="flex flex-col items-center space-y-3">
                    <CallToAction href={cta.url} width={cta.width} type={cta.type}>
                        {cta.label}
                    </CallToAction>
                </div>
            )}
        </div>
    )
}
export default Hero
